/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Injectable } from '@angular/core';
import { SkipperService } from '../services/skipper.service';
import { selectAlertVolume } from '../../call/+state/media.selectors';
import { Store } from '@ngrx/store';

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    private AUDIO_FILE_PATH = '/api/config-mgmt/v1/call-alerts/files/';
    private readonly mediaStreamAudioDestinationNode: MediaStreamAudioDestinationNode;
    private gain = 1;
    public audioFileUrl: string;
    public readonly audioContext: AudioContext;
    public readonly mixerNode: GainNode;
    public readonly mediaStream: MediaStream;

    constructor(private skipperService: SkipperService, private store: Store) {
        this.skipperService.activeUrl$.subscribe((url) => this.audioFileUrl = `${url}${this.AUDIO_FILE_PATH}`);
        console.debug(`Creating alert audio context`);
        this.audioContext = new AudioContext();
        this.mixerNode = this.audioContext.createGain();
        this.mediaStreamAudioDestinationNode = this.audioContext.createMediaStreamDestination();
        this.mixerNode.connect(this.mediaStreamAudioDestinationNode);
        this.mediaStream = this.mediaStreamAudioDestinationNode.stream;
        console.debug(`Acquired alert media stream: ${this.mediaStream.id}`);
        this.store.select(selectAlertVolume).subscribe((volume) => this.setVolume(volume));
    }

    public checkContext() {
        if (this.audioContext.state === 'suspended') {
            this.audioContext
                .resume()
                .then(() => console.debug('Successfully started alert audio context'))
                .catch((err) => console.error('Unable to start alert audio context {}', err));
        }
    }

    /* volume: 1-10 which is converted to a gain of 0.1-2.0 by dividing by 5 */
    public setVolume(volume: number) {
        this.gain = volume / 5;
        console.debug(`Setting gain to ${this.gain} for Alert playback`);
        if (this.mixerNode) this.mixerNode.gain.value = this.gain;
    }
}
